import React, { useRef } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";

let nextTipId = 0;
export default function MemberInfoTip({ message }) {
  const id = useRef(null);
  if (!id.current) id.current = `member-info-${++nextTipId}`;
  return (
    <>
      <button
        type="button"
        className="member-info-tip"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
        aria-label={message}
        data-tooltip-id={id.current}
        style={{
          color: "var(--border1)",
          background: "none",
          border: 0,
          padding: 3,
          cursor: "help",
        }}
      >
        <FaInfoCircle aria-hidden="true" />
      </button>
      <Tooltip
        id={id.current}
        content={message}
        openEvents={{ mouseenter: true, focus: true }}
        closeEvents={{ mouseleave: true, blur: true }}
        style={{ maxWidth: 280, zIndex: 2000 }}
      />
    </>
  );
}
